<template>
	<div v-loading="loading" class="base_scroll_page" style="padding: 15px 15px 15px 200px">
		<!-- 区域选择 -->
		<AreaChoise @nodeClick="handleAreaChoiseSelect"></AreaChoise>
		<!-- 区域选择 end -->

		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="generaler_name" class="b_inp" placeholder="姓名"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">账号：</span>
					<el-input v-model="generaler_code" class="b_inp" placeholder="账号"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">病理类型：</span>
					<el-select v-model="generaler_disease" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in allDisease" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>

				<div class="b_item">
					<span class="b_label">注册医院：</span>
					<el-input v-model="generaler_hospital" class="b_inp" placeholder="注册医院"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">邀请查询：</span>
					<el-select v-model="invite" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option label="有邀请" value="true"></el-option>
						<el-option label="无邀请" value="false"></el-option>
					</el-select>
				</div>

				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="generaler_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					></el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="generaler_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					></el-date-picker>
				</div>

				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->

			<!-- action -->
			<div style="margin-top: 20px; font-size: 0; text-align: right">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddGeneralerClick">新增用户</el-button>
			</div>
			<!-- action end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="diseaseName" label="病理类型"></el-table-column>
					<el-table-column prop="code" label="账号"></el-table-column>
					<el-table-column prop="name" label="姓名"></el-table-column>
					<el-table-column prop="sexLabel" label="性别"></el-table-column>
					<el-table-column prop="doctorName" label="主治医师"></el-table-column>
					<el-table-column prop="hospitalName" label="就诊医院"></el-table-column>
					<el-table-column prop="creater" label="注册人"></el-table-column>
					<el-table-column prop="creatDate" label="注册时间"></el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope">
							<el-dropdown trigger="click">
								<el-button type="primary">
									基本信息
									<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleViewGeneralerClick(scope.row)">查看</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerProductClick(scope.row)">开通产品</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleRechargeGeneralerClick(scope.row)">充值</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerPrescriptionClick(scope.row)">处方</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleResetPasswordClick(scope.row)">重置密码</p>
									</el-dropdown-item>
									<el-dropdown-item v-if="authInfo.ucategory == 1" style="padding: 0">
										<p style="padding: 0 15px" @click="handleInviteRewardClick(scope.row)">成人互联邀请奖励</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleAIReportClick(scope.row)">AI检查评估报告</p>
									</el-dropdown-item>

									<!-- v-if="authInfo.ucategory == 1 || authInfo.loginType == 'xtz' || authInfo.loginType == 'ql'" -->
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleCardActiveClick(scope.row)">充值卡充值</p>
									</el-dropdown-item>

									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleDeleteClick(scope.row)">删除</p>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown trigger="click">
								<el-button type="primary">
									用户记录
									<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerTrainRecordClick(scope.row)">训练记录</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerRechargeRecordClick(scope.row)">充值记录</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerConsumeRecordClick(scope.row)">消费记录</p>
									</el-dropdown-item>

									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handlefyClick(scope.row)">邀请记录</p>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown trigger="click">
								<el-button type="primary">
									反馈信息
									<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleWithTrainingClick(scope.row)">带训信息</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerMedicalClick(scope.row)">病历信息</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerRevisitClick(scope.row)">回访信息</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0">
										<p style="padding: 0 15px" @click="handleGeneralerMemoClick(scope.row)">备忘录</p>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px">
				<div class="base_pager" style="float: right">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页"
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					></el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->

		<!-- 新增用户弹出框 -->
		<Popup v-model="addGeneraler_popup_display" title="新增用户" confirmBtnText="添加" @confirmClick="handleAddGeneralerPopupConfirmClick">
			<div v-loading="add_loading" style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						姓名
					</span>
					<el-input v-model="addGeneraler_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerName_tip">
						<i class="b_icon"></i>
						请输入姓名
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						账号
					</span>
					<el-input v-model="addGeneraler_code" placeholder="邮箱/手机号等"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerCode_tip">
						<i class="b_icon"></i>
						账号格式错误
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						性别
					</span>
					<el-select v-model="addGeneraler_sex" style="width: 100%">
						<el-option :value="0" label="男"></el-option>
						<el-option :value="1" label="女"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						年龄
					</span>
					<el-input v-model="addGeneraler_age" placeholder="年龄"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerAge_tip">
						<i class="b_icon"></i>
						年龄格式错误
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						手机号
					</span>
					<el-input v-model="addGeneraler_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerPhone_tip">
						<i class="b_icon"></i>
						手机号格式错误
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						遮盖处方
					</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="addGeneraler_cover">
							<el-radio :label="0">遮左眼</el-radio>
							<el-radio :label="1">遮右眼</el-radio>
							<el-radio :label="2">不遮盖</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						主治医生
					</span>
					<div style="position: relative">
						<VDistpicker
							:province="addGeneraler_addr.provinceName"
							:city="addGeneraler_addr.cityName"
							:area="addGeneraler_addr.areaName"
							@province="handleAddGeneralerAddrProvinceSelect"
							@city="handleAddGeneralerAddrCitySelect"
							@area="handleAddGeneralerAddrAreaSelect"
						></VDistpicker>
						<i
							v-if="authInfo.ucategory == 3"
							style="display: block; position: absolute; z-index: 9; width: 100%; height: 100%; top: 0; left: 0; background: transparent"
							@click="handleAddGeneralerAddrMaskerClick"
						></i>
					</div>
					<div class="base_tip">
						<template v-if="addGeneralerAddr_tip">
							<i class="b_icon"></i>
							请选择区域
						</template>
					</div>
					<div>
						<el-select v-model="addGeneraler_hospital" placeholder="请先选择区域" style="width: 200px" @change="handleAddGeneralerHospitalSelect">
							<el-option v-for="(v, i) in addGeneraler_hospitals" :key="i" :value="v.id" :label="v.name"></el-option>
						</el-select>
						<div class="base_tip">
							<template v-if="addGeneralerHospital_tip">
								<i class="b_icon"></i>
								请选择医院
							</template>
						</div>
					</div>
					<div>
						<el-select v-model="addGeneraler_doctor" placeholder="请先选择医院" style="width: 200px" @change="handleAddGeneralerDoctorSelect">
							<el-option v-for="(v, i) in addGeneraler_doctors" :key="i" :value="v.uid" :label="v.name"></el-option>
						</el-select>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerDoctor_tip">
						<i class="b_icon"></i>
						请选择主治医生
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						患者类型
					</span>
					<el-select v-model="addGeneraler_disease" placeholder="请选择" style="width: 100%">
						<el-option v-for="v in addGeneraler_diseases" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addGeneralerDisease_tip">
						<i class="b_icon"></i>
						请选择患者类型
					</template>
				</div>
				<div class="base_form_row clear_both">
					<span class="b_label">裸眼视力</span>
					<div class="b_block" style="width: 245px">
						<el-input v-model="addGeneraler_nakedR" placeholder="右眼裸眼视力"></el-input>
						<div class="base_tip">
							<template v-if="addGeneralerNakedR_tip">
								<i class="b_icon"></i>
								右眼裸眼视力格式错误
							</template>
						</div>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input v-model="addGeneraler_nakedL" placeholder="左眼裸眼视力"></el-input>
						<div class="base_tip">
							<template v-if="addGeneralerNakedL_tip">
								<i class="b_icon"></i>
								左眼裸眼视力格式错误
							</template>
						</div>
					</div>
				</div>
				<div class="base_form_row clear_both">
					<span class="b_label">
						<span style="color: #f00">*</span>
						矫正视力
					</span>
					<div class="b_block" style="width: 245px">
						<el-input v-model="addGeneraler_correctionR" placeholder="右眼矫正视力"></el-input>
						<div class="base_tip">
							<template v-if="addGeneralerCorrectionR_tip">
								<i class="b_icon"></i>
								右眼矫正视力格式错误
							</template>
						</div>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input v-model="addGeneraler_correctionL" placeholder="左眼矫正视力"></el-input>
						<div class="base_tip">
							<template v-if="addGeneralerCorrectionL_tip">
								<i class="b_icon"></i>
								左眼矫正视力格式错误
							</template>
						</div>
					</div>
				</div>
				<div class="base_form_row">
					<span class="b_label">备注</span>
					<el-input v-model="addGeneraler_remark" maxlength="100" :show-word-limit="true" placeholder="备注"></el-input>
				</div>
			</div>
		</Popup>
		<!-- 新增用户弹出框 end -->

		<!-- 查看用户弹出框 -->
		<Popup v-model="viewGeneraler_popup_display" title="查看用户" confirmBtnText="修改"  @confirmClick="handleUpdateGeneralerClick">
			<div style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">姓名</span>
					<el-input :value="viewGeneraler_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">账号</span>
					<el-input :value="viewGeneraler_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">性别</span>
					<el-select :value="viewGeneraler_sex" disabled style="width: 100%"></el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">年龄</span>
					<el-input :value="viewGeneraler_age" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">手机号</span>
					<el-input :value="viewGeneraler_phone" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">遮盖处方</span>
					<el-input :value="viewGeneraler_cover" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">所属区域</span>
					<div class="b_select">
						<el-select :value="viewGeneraler_addr.provinceName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewGeneraler_addr.cityName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewGeneraler_addr.areaName" disabled></el-select>
					</div>
				</div>
				<div class="base_form_row clear_both" style="margin-top: 20px">
					<span class="b_label">裸眼视力</span>
					<div class="b_block" style="width: 245px">
						<el-input :value="viewGeneraler_nakedR" disabled></el-input>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input :value="viewGeneraler_nakedL" disabled></el-input>
					</div>
				</div>
				<div class="base_form_row clear_both" style="margin-top: 20px">
					<span class="b_label">矫正视力</span>
					<div class="b_block" style="width: 245px">
						<el-input :value="viewGeneraler_correctionR" disabled></el-input>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input :value="viewGeneraler_correctionL" disabled></el-input>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">备注</span>
					<el-input :value="viewGeneraler_remark" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">注册人</span>
					<el-input :value="viewGeneraler_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">注册时间</span>
					<el-input :value="viewGeneraler_creatDate" disabled></el-input>
				</div>
				<div class="base_doc" style="margin-top: 20px">
					<table>
						<tr class="b_tt">
							<td colspan="4" style="text-align: center">消费信息</td>
						</tr>
						<tr class="b_tt">
							<td style="text-align: center">项目</td>
							<td style="text-align: center">已充值次数</td>
							<td style="text-align: center">已消费次数</td>
							<td style="text-align: center">剩余次数</td>
						</tr>
						<tr v-for="v in viewGeneraler_consumeInfo" :key="v.uversionFlag">
							<td>{{ v.name }}</td>
							<td>{{ v.u_r_total_time || 0 }}</td>
							<td>{{ v.u_c_total_time || 0 }}</td>
							<td>{{ v.urcTime || 0 }}</td>
						</tr>
					</table>
				</div>
			</div>
		</Popup>
		<!-- 查看用户弹出框 end -->

		<!-- 更新用户弹出框 -->
		<Popup v-model="updateGeneraler_popup_display" title="更新用户" confirmBtnText="更新" @confirmClick="handleUpdateGeneralerPopupConfirmClick">
			<div v-loading="update_loading" style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						账号
					</span>
					<el-input :value="updateGeneraler_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						姓名
					</span>
					<el-input v-model="updateGeneraler_name" placeholder="姓名" :disabled='!powerInfo'></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerName_tip">
						<i class="b_icon"></i>
						请输入姓名
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						性别
					</span>
					<el-select v-model="updateGeneraler_sex" style="width: 100%">
						<el-option :value="0" label="男"></el-option>
						<el-option :value="1" label="女"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerSex_tip">
						<i class="b_icon"></i>
						请选择性别
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						年龄
					</span>
					<el-input v-model="updateGeneraler_age" placeholder="年龄"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerAge_tip">
						<i class="b_icon"></i>
						年龄格式错误
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						手机号
					</span>
					<el-input v-model="updateGeneraler_phone" placeholder="手机号" :disabled='!powerInfo'></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerPhone_tip">
						<i class="b_icon"></i>
						手机号格式错误
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						遮盖处方
					</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="updateGeneraler_cover">
							<el-radio :label="0">遮左眼</el-radio>
							<el-radio :label="1">遮右眼</el-radio>
							<el-radio :label="2">不遮盖</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						主治医生
					</span>
					<VDistpicker
						:province="updateGeneraler_addr.provinceName"
						:city="updateGeneraler_addr.cityName"
						:area="updateGeneraler_addr.areaName"
						@province="handleUpdateGeneralerAddrProvinceSelect"
						@city="handleUpdateGeneralerAddrCitySelect"
						@area="handleUpdateGeneralerAddrAreaSelect"
					></VDistpicker>
					<div class="base_tip">
						<template v-if="updateGeneralerAddr_tip">
							<i class="b_icon"></i>
							请选择区域
						</template>
					</div>
					<div>
						<el-select v-model="updateGeneraler_hospital" placeholder="请先选择区域" style="width: 200px" @change="handleUpdateGeneralerHospitalSelect">
							<el-option v-for="(v, i) in updateGeneraler_hospitals" :key="i" :value="v.id" :label="v.name"></el-option>
						</el-select>
						<div class="base_tip">
							<template v-if="updateGeneralerHospital_tip">
								<i class="b_icon"></i>
								请选择医院
							</template>
						</div>
					</div>
					<div>
						<el-select v-model="updateGeneraler_doctor" placeholder="请先选择医院" style="width: 200px" @change="handleUpdateGeneralerDoctorSelect">
							<el-option v-for="(v, i) in updateGeneraler_doctors" :key="i" :value="v.uid" :label="v.name"></el-option>
						</el-select>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerDoctor_tip">
						<i class="b_icon"></i>
						请选择主治医生
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						患者类型
					</span>
					<el-select v-model="updateGeneraler_disease" placeholder="请选择" style="width: 100%">
						<el-option v-for="v in updateGeneraler_diseases" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateGeneralerDisease_tip">
						<i class="b_icon"></i>
						请选择患者类型
					</template>
				</div>
				<div class="base_form_row clear_both">
					<span class="b_label">裸眼视力</span>
					<div class="b_block" style="width: 245px">
						<el-input v-model="updateGeneraler_nakedR" placeholder="右眼裸眼视力"></el-input>
						<div class="base_tip">
							<template v-if="updateGeneralerNakedR_tip">
								<i class="b_icon"></i>
								右眼裸眼视力格式错误
							</template>
						</div>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input v-model="updateGeneraler_nakedL" placeholder="左眼裸眼视力"></el-input>
						<div class="base_tip">
							<template v-if="updateGeneralerNakedL_tip">
								<i class="b_icon"></i>
								左眼裸眼视力格式错误
							</template>
						</div>
					</div>
				</div>
				<div class="base_form_row clear_both">
					<span class="b_label">
						<span style="color: #f00">*</span>
						矫正视力
					</span>
					<div class="b_block" style="width: 245px">
						<el-input v-model="updateGeneraler_correctionR" placeholder="右眼矫正视力"></el-input>
						<div class="base_tip">
							<template v-if="updateGeneralerCorrectionR_tip">
								<i class="b_icon"></i>
								右眼矫正视力格式错误
							</template>
						</div>
					</div>
					<div class="b_block" style="width: 245px; margin-left: 20px">
						<el-input v-model="updateGeneraler_correctionL" placeholder="左眼矫正视力"></el-input>
						<div class="base_tip">
							<template v-if="updateGeneralerCorrectionL_tip">
								<i class="b_icon"></i>
								左眼矫正视力格式错误
							</template>
						</div>
					</div>
				</div>
				<div class="base_form_row">
					<span class="b_label">备注</span>
					<el-input v-model="updateGeneraler_remark" maxlength="100" :show-word-limit="true" placeholder="备注"></el-input>
				</div>
			</div>
		</Popup>
		<!-- 更新用户弹出框 end -->

		<!-- 开通产品弹出框 -->
		<product
			v-model="generalerProduct_popup_display"
			:products="userProducts"
			:uid="generalerProduct_uid"
			:code="generalerProduct_code"
			:formId="generalerProduct_hospitalId"
			@updateProduct="handleUpdateProduct"
		></product>
		<!-- 开通产品弹出框 end -->

		<!-- 充值弹出框 -->
		<recharge
			v-model="rechargeGeneraler_popup_display"
			:id="rechargeGeneraler_id"
			:name="rechargeGeneraler_name"
			:code="rechargeGeneraler_code"
			:products="userProducts"
			:objectType="0"
			:powerInfo='powerInfo'
			@success="handleRechargeSuccess"
		></recharge>
		<!-- 充值弹出框 end -->

		<!-- 处方弹出框 -->
		<prescription
			v-model="generalerPrescription_popup_display"
			:uid="generalerPrescription_uid"
			:fid="generalerPrescription_fid"
			:code="generalerPrescription_code"
			@updatePrescription="handleUpdatePrescription"
		></prescription>
		<!-- 处方弹出框 end -->

		<!-- 重置密码弹出框 -->
		<reset-password
			v-model="resetPassword_display"
			borw="1"
			:oid="resetPassword_oid"
			:code="resetPassword_code"
			:phone="resetPassword_phone"
			@success="handleResetPasswordSuccess"
		></reset-password>
		<!-- 重置密码弹出框弹出框 end -->

		<!-- 邀请奖励弹出框 -->
		<invite-reward v-model="inviteReward_display" :uid="inviteReward_uid"></invite-reward>
		<!-- 邀请奖励弹出框 end -->

		<!-- 病历弹出框 -->
		<medical v-model="generalerMedical_popup_display" :code="generalerMedical_code" :formId="generalerMedical_formId"></medical>
		<!-- 病历弹出框 end -->

		<!-- 健康档案弹出框 -->
		<health-doc :uid="generalerHealthDoc_uid" v-model="generalerHealthDoc_popup_display"></health-doc>
		<!-- 健康档案弹出框 end -->

		<!-- 回访弹出框 -->
		<re-visit v-model="generalerRevisit_popup_display" :uid="generalerRevisit_uid" @addRevisit="addRevisit" @deleteRevisit="deleteRevisit"></re-visit>
		<!-- 回访弹出框 end -->

		<!-- 充值记录弹出框 -->
		<recharge-record v-model="generalerRechargeRecord_popup_display" :id="generalerRechargeRecord_id" :code="generalerRechargeRecord_code" type="0"></recharge-record>
		<!-- 充值记录弹出框 end -->

		<!-- 训练记录弹出框 -->
		<training-record
			v-model="generalerTrainRecord_popup_display"
			:uid="generalerTrainRecord_uid"
			:fid="generalerTrainRecord_fid"
			:code="generalerTrainRecord_code"
		></training-record>
		<!-- 训练记录弹出框 end -->

		<!-- 消费记录弹出框 -->
		<consume-record v-model="generalerConsumeRecord_popup_display" :id="generalerConsumeRecord_id" :code="generalerConsumeRecord_code" type="0"></consume-record>
		<!-- 消费记录弹出框 end -->

		<!-- 邀请用户列表弹出框 -->
		<fy-record v-model="fy_popup_display" :id="fy_id" :code="fy_code" type="0"></fy-record>
		<!-- 邀请用户列表弹出框 end -->

		<!-- 带训信息弹出框 -->
		<with-training
			v-model="widthTraining_display"
			:uid="widthTraining_uid"
			:code="widthTraining_code"
			:firmId="widthTraining_firmId"
			:firmName="widthTraining_firmName"
		></with-training>
		<!-- 带训信息弹出框 end -->

		<!-- 备忘录弹出框 -->
		<memo v-model="memo_display" :uid="memo_uid" :firmId="memo_firmId" :firmName="memo_firmName" :code="memo_code" :name="memo_name"></memo>
		<!-- 备忘录弹出框 end -->

		<!-- AI检查评估报告 -->
		<AI-report v-model="AIReport_display" :obj="AIReport_data"></AI-report>
		<!-- AI检查评估报告 end -->

		<!-- 充值卡充值弹出框 -->
		<card-active v-model="cardActive_display" :id="cardActive_id"></card-active>
	</div>
</template>

<script>
import AreaChoise from '../components/area_choise.vue';
import Api from '../../../../api/index.js';
import { mapState,mapGetters  } from 'vuex';
import BaseMethods from '../../../../assets/js/base.js';
import ResetPassword from './components/reset_password.vue';
import InviteReward from './components/invite_reward.vue';
import Recharge from './components/recharge.vue';
import RechargeRecord from './components/recharge_record.vue';
import ConsumeRecord from './components/consume_record.vue';
import FyRecord from './components/fy_record.vue'; //邀请记录列表
import TrainingRecord from './components/training_record.vue';
import Product from './components/product.vue';
import Prescription from './components/prescription.vue';
import ReVisit from './components/revisit.vue';
import Medical from './components/medical.vue';
import HealthDoc from './components/health_doc.vue';
import WithTraining from './components/with_training.vue';
import Memo from './components/memo.vue';
import AIReport from './components/AI_report.vue';
import CardActive from './components/card_active.vue';

export default {
	mounted() {
		this.addComplete = false;
		this.addId = '';
		this.addCode = '';
		this.addFirmId = '';
		this.addName = '';
		this.getUserList();
		this.ucode = this.authInfo.ucode;
	},
	data() {
		return {
			invite: '',
			ucode: '', //查询判断哪个账号可以重置密码
			loading: false,
			tableData: [],

			currentPage: 1,
			total: 0,

			generaler_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			generaler_name: '',
			generaler_code: '',
			generaler_disease: '',
			generaler_hospital: '',
			generaler_startTime: '',
			generaler_endTime: '',

			add_loading: false,
			addGeneraler_popup_display: false,
			addGeneraler_name: '',
			addGeneraler_code: '',
			addGeneraler_sex: 0,
			addGeneraler_age: '',
			addGeneraler_phone: '',
			addGeneraler_cover: 2,
			addGeneraler_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			addGeneraler_hospital: '',
			addGeneraler_hospitals: [],
			addGeneraler_doctor: '',
			addGeneraler_doctors: [],
			addGeneraler_disease: '',
			addGeneraler_diseases: [],
			addGeneraler_nakedR: '',
			addGeneraler_nakedL: '',
			addGeneraler_correctionR: '',
			addGeneraler_correctionL: '',
			addGeneraler_remark: '',
			addGeneralerName_tip: false,
			addGeneralerCode_tip: false,
			addGeneralerAge_tip: false,
			addGeneralerPhone_tip: false,
			addGeneralerAddr_tip: false,
			addGeneralerHospital_tip: false,
			addGeneralerDoctor_tip: false,
			addGeneralerDisease_tip: false,
			addGeneralerNakedR_tip: false,
			addGeneralerNakedL_tip: false,
			addGeneralerCorrectionR_tip: false,
			addGeneralerCorrectionL_tip: false,

			viewGeneraler_popup_display: false,
			viewGeneraler_data: {},
			viewGeneraler_name: '',
			viewGeneraler_code: '',
			viewGeneraler_sex: '',
			viewGeneraler_age: '',
			viewGeneraler_phone: '',
			viewGeneraler_cover: '',
			viewGeneraler_addr: {
				provinceName: '',
				cityName: '',
				areaName: ''
			},
			viewGeneraler_nakedR: '',
			viewGeneraler_nakedL: '',
			viewGeneraler_correctionR: '',
			viewGeneraler_correctionL: '',
			viewGeneraler_remark: '',
			viewGeneraler_creater: '',
			viewGeneraler_creatDate: '',
			viewGeneraler_consumeInfo: [],

			update_loading: false,
			updateGeneraler_popup_display: false,
			updateGeneraler_id: '',
			updateGeneraler_code: '',
			updateGeneraler_name: '',
			updateGeneraler_sex: '',
			updateGeneraler_age: '',
			updateGeneraler_phone: '',
			updateGeneraler_cover: 2,
			updateGeneraler_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			updateGeneraler_hospital: '',
			updateGeneraler_hospitals: [],
			updateGeneraler_doctor: '',
			updateGeneraler_doctors: [],
			updateGeneraler_disease: '',
			updateGeneraler_diseases: [],
			updateGeneraler_nakedR: '',
			updateGeneraler_nakedL: '',
			updateGeneraler_correctionR: '',
			updateGeneraler_correctionL: '',
			updateGeneraler_remark: '',
			updateGeneralerName_tip: false,
			updateGeneralerSex_tip: false,
			updateGeneralerAge_tip: false,
			updateGeneralerPhone_tip: false,
			updateGeneralerAddr_tip: false,
			updateGeneralerHospital_tip: false,
			updateGeneralerDoctor_tip: false,
			updateGeneralerDisease_tip: false,
			updateGeneralerNakedR_tip: false,
			updateGeneralerNakedL_tip: false,
			updateGeneralerCorrectionR_tip: false,
			updateGeneralerCorrectionL_tip: false,

			generalerProduct_popup_display: false,
			generalerProduct_uid: '',
			generalerProduct_code: '',
			generalerProduct_hospitalId: '',

			rechargeGeneraler_popup_display: false,
			rechargeGeneraler_id: '',
			rechargeGeneraler_name: '',
			rechargeGeneraler_code: '',

			generalerPrescription_popup_display: false,
			generalerPrescription_uid: '',
			generalerPrescription_fid: '',
			generalerPrescription_code: '',

			generalerTrainRecord_popup_display: false,
			generalerTrainRecord_uid: '',
			generalerTrainRecord_fid: '',
			generalerTrainRecord_code: '',

			resetPassword_display: false,
			resetPassword_oid: '',
			resetPassword_phone: '',
			resetPassword_code: '',

			inviteReward_display: false,
			inviteReward_uid: '',

			generalerMedical_popup_display: false,
			generalerMedical_code: '',
			generalerMedical_formId: '',

			generalerHealthDoc_popup_display: false,
			generalerHealthDoc_uid: '',

			generalerRevisit_popup_display: false,
			generalerRevisit_uid: '',

			generalerRechargeRecord_popup_display: false,
			generalerRechargeRecord_id: '',
			generalerRechargeRecord_code: '',

			generalerConsumeRecord_popup_display: false,
			generalerConsumeRecord_id: '',
			generalerConsumeRecord_code: '',

			fy_popup_display: false,
			fy_id: '',
			fy_code: '',

			widthTraining_display: false,
			widthTraining_uid: '',
			widthTraining_code: '',
			widthTraining_firmId: '',
			widthTraining_firmName: '',

			memo_display: false,
			memo_uid: '',
			memo_firmId: '',
			memo_firmName: '',
			memo_code: '',
			memo_name: '',

			AIReport_display: false,
			AIReport_data: {},

			userProducts: [],

			cardActive_id: '',
			cardActive_display: false
		};
	},
	computed: {
		...mapState(['authInfo', 'allDisease', 'authProduct', 'allProduct']),...mapGetters (['powerInfo'])
	},
	methods: {
		/************************ @Events *******************************/
		// 选择城市
		handleAreaChoiseSelect(data) {
			if (data.sign == 'P') {
				this.generaler_addr.provinceCode = data.key.slice(0, 3);
				this.generaler_addr.provinceName = data.label;
				this.generaler_addr.cityCode = '';
				this.generaler_addr.cityName = '';
				this.generaler_addr.areaCode = '';
				this.generaler_addr.areaName = '';
				this.currentPage = 1;
				this.getUserList();
			} else if (data.sign == 'C') {
				this.generaler_addr.provinceCode = data.parentKey.slice(0, 3);
				this.generaler_addr.provinceName = data.parentLabel;
				this.generaler_addr.cityCode = data.key + '000000';
				this.generaler_addr.cityName = data.label;
				this.generaler_addr.areaCode = '';
				this.generaler_addr.areaName = '';
				this.currentPage = 1;
				this.getUserList();
			} else if (data.sign == 'A') {
				this.generaler_addr.provinceCode = data.grandKey.slice(0, 3);
				this.generaler_addr.provinceName = data.grandLabel;
				this.generaler_addr.cityCode = data.parentKey + '000000';
				this.generaler_addr.cityName = data.parentLabel;
				this.generaler_addr.areaCode = data.key + '000000';
				this.generaler_addr.areaName = data.label;
				this.currentPage = 1;
				this.getUserList();
			} else {
				this.generaler_addr.provinceCode = '';
				this.generaler_addr.provinceName = '';
				this.generaler_addr.cityCode = '';
				this.generaler_addr.cityName = '';
				this.generaler_addr.areaCode = '';
				this.generaler_addr.areaName = '';
				this.currentPage = 1;
				this.getUserList();
			}
		},
		// 切换查询时间
		handleSearchStartTimeClick() {
			this.compareSearchTime();
		},
		// 切换查询时间
		handleSearchEndTimeClick() {
			this.compareSearchTime();
		},
		// 点击查询
		handleSearchClick() {
			this.currentPage = 1;
			this.getUserList();
		},
		// 点击页码
		handlePageChange(page) {
			if (this.currentPage != page) {
				this.currentPage = page;
				this.getUserList();
			}
		},
		// 导出Excel数据
		exportExcel() {
			const that = this;
			that.loading = true;
			var _requestData = {
				creater: null,
				endTime: that.generaler_endTime,
				limit: 10000,
				pageNum: 1,
				startTime: that.generaler_startTime,
				uareaName: that.generaler_addr.areaName,
				ucityName: that.generaler_addr.cityName,
				ucode: that.generaler_code,
				udiseasesId: that.generaler_disease,
				uenterpriseName: that.generaler_hospital,
				ufinderCategory: null,
				uid: null,
				uloginerCategory: that.authInfo.ucategory,
				uphone: null,
				uprovinceName: that.generaler_addr.provinceName,
				username: that.generaler_name,
				userId: that.authInfo.uid,
				uenterpriseId: that.authInfo.uenterpriseId,
				functionType: 2
			};
			Api.findUser(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,类型,账号,姓名,性别,主治医师,就诊医院,注册人,注册时间,\n';
						for (var i = 0; i < res.data.data.data.length; i++) {
							str += `${i + 1},`;
							str += res.data.data.data[i].udiseasesName || '';
							str += ',';
							str += res.data.data.data[i].ucode || '';
							str += '\t,';
							str += res.data.data.data[i].name || '';
							str += ',';
							str += res.data.data.data[i].sex == 0 ? '男' : res.data.data.data[i].sex == 1 ? '女' : '';
							str += ',';
							str += res.data.data.data[i].doctorName || '';
							str += ',';
							str += res.data.data.data[i].uenterpriseName || '';
							str += ',';
							str += res.data.data.data[i].creater || '';
							str += ',';
							str += res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split('T')[0] : '';
							str += '\t,';
							str += '\n';
							// data.push({
							// 	diseaseName: res.data.data.data[i].udiseasesName || '',
							// 	code: res.data.data.data[i].ucode || '',
							// 	name: res.data.data.data[i].name || '',
							// 	sex: res.data.data.data[i].sex == 0
							// 			? '男'
							// 			: res.data.data.data[i].sex == 1
							// 				? '女'
							// 				: '',
							// 	doctorName: res.data.data.data[i].doctorName || '',
							// 	hospitalName: res.data.data.data[i].uenterpriseName || '',
							// 	creater: res.data.data.data[i].creater || '',
							// 	creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : ''
							// });
						}
						BaseMethods.outputExcel(str, '普通用户');
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 点击新增
		handleAddGeneralerClick() {
			this.add_loading = false;
			this.addGeneraler_name = '';
			this.addGeneraler_code = '';
			this.addGeneraler_sex = 0;
			this.addGeneraler_age = '';
			this.addGeneraler_phone = '';
			this.addGeneraler_cover = 2;
			this.addGeneraler_addr = {
				provinceName: this.authInfo.uprovinceName || '',
				provinceCode: this.authInfo.uprovinceCode || '',
				cityName: this.authInfo.ucityName || '',
				cityCode: this.authInfo.ucityCode || '',
				areaName: this.authInfo.uareaName || '',
				areaCode: this.authInfo.uareaCode || ''
			};
			this.addGeneraler_hospital = '';
			this.addGeneraler_hospitals = [];
			this.addGeneraler_doctor = '';
			this.addGeneraler_doctors = [];
			this.addGeneraler_disease = '';
			this.addGeneraler_diseases = [];
			this.addGeneraler_nakedR = '';
			this.addGeneraler_nakedL = '';
			this.addGeneraler_correctionR = '';
			this.addGeneraler_correctionL = '';
			this.addGeneralerName_tip = '';
			this.addGeneralerCode_tip = '';
			this.addGeneralerAge_tip = '';
			this.addGeneralerPhone_tip = '';
			this.addGeneralerAddr_tip = false;
			this.addGeneralerHospital_tip = false;
			this.addGeneralerDoctor_tip = false;
			this.addGeneralerDisease_tip = false;
			this.addGeneralerNakedR_tip = false;
			this.addGeneralerNakedL_tip = false;
			this.addGeneralerCorrectionR_tip = false;
			this.addGeneralerCorrectionL_tip = false;
			this.addGeneraler_popup_display = true;
			this.addGeneraler_addr.areaCode && this.findAddHospital(true);
		},
		// 新增地址省份选择
		handleAddGeneralerAddrProvinceSelect(data) {
			this.addGeneraler_addr.provinceName = data.code ? data.value : '';
			this.addGeneraler_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
		},
		// 新增地址城市选择
		handleAddGeneralerAddrCitySelect(data) {
			this.addGeneraler_addr.cityName = data.code ? data.value : '';
			this.addGeneraler_addr.cityCode = data.code ? `${data.code}000000` : '';
		},
		// 新增地址区域选择
		handleAddGeneralerAddrAreaSelect(data) {
			this.addGeneraler_addr.areaName = data.code ? data.value : '';
			this.addGeneraler_addr.areaCode = data.code ? `${data.code}000000` : '';
			if (this.addGeneraler_addr.areaCode) {
				this.addGeneraler_hospital = '';
				this.addGeneraler_hospitals = [];
				this.addGeneraler_doctor = '';
				this.addGeneraler_doctors = [];
				this.addGeneraler_disease = '';
				this.addGeneraler_diseases = [];
				this.findAddHospital();
			} else {
				this.addGeneraler_hospital = '';
				this.addGeneraler_hospitals = [];
				this.addGeneraler_doctor = '';
				this.addGeneraler_doctors = [];
			}
		},
		// 新增地址遮罩层点击
		handleAddGeneralerAddrMaskerClick() {
			this.$message({
				message: '尊敬的医生，此处不能选择',
				type: 'warning'
			});
		},
		// 切换新增医院
		handleAddGeneralerHospitalSelect() {
			this.addGeneraler_doctor = '';
			this.addGeneraler_doctors = [];
			this.addGeneraler_disease = '';
			this.addGeneraler_diseases = [];
			this.findAddDoctors();
		},
		// 切换新增医生
		handleAddGeneralerDoctorSelect() {
			this.addGeneraler_disease = '';
			this.addGeneraler_diseases = [];
			this.findAddDiseaseByDoctor();
		},
		// 点击新增弹框确定按钮
		handleAddGeneralerPopupConfirmClick() {
			const that = this;
			if (!that.addGeneraler_name.trim()) {
				// 校验姓名
				that.addGeneralerName_tip = true;
				return false;
			} else {
				that.addGeneralerName_tip = false;
			}
			if (!that.phoneReg.test(that.addGeneraler_code)) {
				// 校验账号
				that.addGeneralerCode_tip = true;
				return false;
			} else {
				that.addGeneralerCode_tip = false;
			}
			if (!that.ageReg.test(that.addGeneraler_age)) {
				// 校验年龄
				that.addGeneralerAge_tip = true;
				return false;
			} else {
				that.addGeneralerAge_tip = false;
			}
			if (!that.phoneReg.test(that.addGeneraler_phone)) {
				// 校验手机号
				that.addGeneralerPhone_tip = true;
				return false;
			} else {
				that.addGeneralerPhone_tip = false;
			}
			if (!that.addGeneraler_addr.areaCode) {
				// 校验区域
				that.addGeneralerAddr_tip = true;
				return false;
			} else {
				that.addGeneralerAddr_tip = false;
			}
			if (!that.addGeneraler_hospital) {
				// 校验区域
				that.addGeneralerHospital_tip = true;
				return false;
			} else {
				that.addGeneralerHospital_tip = false;
			}
			if (!that.addGeneraler_doctor) {
				// 校验区域
				that.addGeneralerDoctor_tip = true;
				return false;
			} else {
				that.addGeneralerDoctor_tip = false;
			}
			if (!that.addGeneraler_disease) {
				// 校验区域
				that.addGeneralerDisease_tip = true;
				return false;
			} else {
				that.addGeneralerDisease_tip = false;
			}
			if (that.addGeneraler_nakedR || that.addGeneraler_nakedL) {
				if (!that.visionReg.test(that.addGeneraler_nakedR)) {
					// 校验右眼裸眼视力
					that.addGeneralerNakedR_tip = true;
					return false;
				} else {
					that.addGeneralerNakedR_tip = false;
				}
				if (!that.visionReg.test(that.addGeneraler_nakedL)) {
					// 校验左眼裸眼视力
					that.addGeneralerNakedL_tip = true;
					return false;
				} else {
					that.addGeneralerNakedL_tip = false;
				}
			} else {
				that.addGeneralerNakedR_tip = false;
				that.addGeneralerNakedL_tip = false;
			}
			if (!that.visionReg.test(that.addGeneraler_correctionR)) {
				// 校验右眼矫正视力
				that.addGeneralerCorrectionR_tip = true;
				return false;
			} else {
				that.addGeneralerCorrectionR_tip = false;
			}
			if (!that.visionReg.test(that.addGeneraler_correctionL)) {
				// 校验左眼矫正视力
				that.addGeneralerCorrectionL_tip = true;
				return false;
			} else {
				that.addGeneralerCorrectionL_tip = false;
			}
			that.loading = true;
			var _requestData = {
				id: null,
				openUmBUserVo: {
					isExamine: null,
					uareaCode: null,
					uareaName: null,
					ucategory: null,
					ucategorySpecific: null,
					ucityCode: null,
					ucityName: null,
					ucode: null,
					ucreate: null,
					ucreateTs: null,
					uenterpriseId: that.addGeneraler_hospital,
					uexpert: null,
					uid: null,
					ulevel: null,
					uname: null,
					unationalityCode: null,
					unationalityName: null,
					uphone: null,
					uprovinceCode: null,
					uprovinceName: null,
					usex: null
				},
				openUmWUserVo: {
					u_r_name: that.addGeneraler_name,
					uaddressToAreaCode: null,
					uaddressToAreaName: null,
					uaddressToCityCode: null,
					uaddressToCityName: null,
					uaddressToNationalityCode: null,
					uaddressToNationalityName: null,
					uaddressToProvinceCode: null,
					uaddressToProvinceName: null,
					uage: that.addGeneraler_age,
					uareaCode: that.addGeneraler_addr.areaCode,
					uareaName: that.addGeneraler_addr.areaName,
					uattendingDoctor: that.addGeneraler_doctor,
					ucityCode: that.addGeneraler_addr.cityCode,
					ucityName: that.addGeneraler_addr.cityName,
					ucode: that.addGeneraler_code,
					udiseasesId: that.addGeneraler_disease,
					uid: null,
					uleftCva: that.addGeneraler_correctionL,
					uleftNeva: that.addGeneraler_nakedL,
					memo: that.addGeneraler_remark,
					unationalityCode: null,
					unationalityName: null,
					uoverspreadEye: that.addGeneraler_cover,
					uphone: that.addGeneraler_phone,
					uprovinceCode: that.addGeneraler_addr.provinceCode,
					uprovinceName: that.addGeneraler_addr.provinceName,
					urightCva: that.addGeneraler_correctionR,
					urightNeva: that.addGeneraler_nakedR,
					usex: that.addGeneraler_sex
				},
				type: 'w',
				ucode: that.authInfo.ucode
			};
			Api.addUser(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.addGeneraler_popup_display = false;
						that.getUserList();
						that.findUserInfo(that.addGeneraler_code, (ret) => {
							that.addComplete = true;
							that.addId = ret.uid;
							that.addCode = ret.ucode;
							that.addFirmId = ret.uenterpriseId;
							that.addName = ret.u_r_name;
							that.userProducts = [];
							that.generalerProduct_uid = that.addId;
							that.generalerProduct_code = that.addCode;
							that.generalerProduct_hospitalId = that.addFirmId;
							that.generalerProduct_popup_display = true;
						});
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 点击查看
		handleViewGeneralerClick(data) {
			const that = this;
			that.viewGeneraler_data = data;
			that.viewGeneraler_name = data.name;
			that.viewGeneraler_code = data.code;
			that.viewGeneraler_sex = data.sexLabel;
			that.viewGeneraler_age = data.age;
			that.viewGeneraler_phone = data.phone;
			that.viewGeneraler_cover = data.coverName;
			that.viewGeneraler_addr = {
				provinceName: data.provinceName,
				cityName: data.cityName,
				areaName: data.areaName
			};
			that.viewGeneraler_nakedR = data.nakedR;
			that.viewGeneraler_nakedL = data.nakedL;
			that.viewGeneraler_correctionR = data.correctionR;
			that.viewGeneraler_correctionL = data.correctionL;
			that.viewGeneraler_remark = data.remark;
			that.viewGeneraler_creater = data.creater;
			that.viewGeneraler_creatDate = data.creatDate;
			that.viewGeneraler_consumeInfo = [];
			that.loading = true;
			var requestData = {
				uUserId: data.id
			};
			Api.findUserDetailInfo(requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						for (var w = 0; w < res.data.data.urlist.length; w++) {
							var o = res.data.data.urlist[w];
							for (var i = 0; i < that.allProduct.length; i++) {
								if (o.uversionFlag == that.allProduct[i].id) {
									o.name = that.allProduct[i].name;
								}
							}
							that.viewGeneraler_consumeInfo.push(o);
						}
						that.viewGeneraler_popup_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 点击更新
		handleUpdateGeneralerClick() {
			let data = this.viewGeneraler_data;
			this.viewGeneraler_popup_display = false;
			this.update_loading = false;
			this.updateGeneraler_id = data.id;
			this.updateGeneraler_code = data.code;
			this.updateGeneraler_name = data.name;
			this.updateGeneraler_sex = data.sex || 0;
			this.updateGeneraler_age = data.age;
			this.updateGeneraler_phone = data.phone;
			this.updateGeneraler_cover = data.cover == -1 ? 2 : data.cover;
			this.updateGeneraler_addr = {
				provinceName: data.provinceName,
				provinceCode: data.provinceCode,
				cityName: data.cityName,
				cityCode: data.cityCode,
				areaName: data.areaName,
				areaCode: data.areaCode
			};
			this.updateGeneraler_hospital = '';
			this.updateGeneraler_hospitals = [];
			this.updateGeneraler_doctor = '';
			this.updateGeneraler_doctors = [];
			this.updateGeneraler_disease = '';
			this.updateGeneraler_diseases = [];
			this.updateGeneraler_nakedR = data.nakedR;
			this.updateGeneraler_nakedL = data.nakedL;
			this.updateGeneraler_correctionR = data.correctionR;
			this.updateGeneraler_correctionL = data.correctionL;
			this.updateGeneralerName_tip = false;
			this.updateGeneralerAge_tip = false;
			this.updateGeneralerPhone_tip = false;
			this.updateGeneralerAddr_tip = false;
			this.updateGeneralerHospital_tip = false;
			this.updateGeneralerDoctor_tip = false;
			this.updateGeneralerDisease_tip = false;
			this.updateGeneralerNakedR_tip = false;
			this.updateGeneralerNakedL_tip = false;
			this.updateGeneralerCorrectionR_tip = false;
			this.updateGeneralerCorrectionL_tip = false;
			this.updateGeneraler_popup_display = true;
			this.findUpdateHospital(data);
		},
		// 更新用户地址省份选择
		handleUpdateGeneralerAddrProvinceSelect(data) {
			this.updateGeneraler_addr.provinceName = data.code ? data.value : '';
			this.updateGeneraler_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
		},
		// 更新用户地址城市选择
		handleUpdateGeneralerAddrCitySelect(data) {
			this.updateGeneraler_addr.cityName = data.code ? data.value : '';
			this.updateGeneraler_addr.cityCode = data.code ? `${data.code}000000` : '';
		},
		// 更新用户地址区域选择
		handleUpdateGeneralerAddrAreaSelect(data) {
			this.updateGeneraler_addr.areaName = data.code ? data.value : '';
			this.updateGeneraler_addr.areaCode = data.code ? `${data.code}000000` : '';
			if (this.updateGeneraler_addr.areaCode) {
				this.updateGeneraler_hospital = '';
				this.updateGeneraler_hospitals = [];
				this.updateGeneraler_doctor = '';
				this.updateGeneraler_doctors = [];
				this.updateGeneraler_disease = '';
				this.updateGeneraler_diseases = [];
				this.findUpdateHospital();
			} else {
				this.updateGeneraler_hospital = '';
				this.updateGeneraler_hospitals = [];
				this.updateGeneraler_doctor = '';
				this.updateGeneraler_doctors = [];
			}
		},
		// 切换更新医院
		handleUpdateGeneralerHospitalSelect() {
			this.updateGeneraler_doctor = '';
			this.updateGeneraler_doctors = [];
			this.updateGeneraler_disease = '';
			this.updateGeneraler_diseases = [];
			this.findUpdateDoctors();
		},
		// 切换更新医生
		handleUpdateGeneralerDoctorSelect() {
			this.updateGeneraler_disease = '';
			this.updateGeneraler_diseases = [];
			this.findUpdateDiseaseByDoctor();
		},
		// 点击更新弹框确定按钮
		handleUpdateGeneralerPopupConfirmClick() {
			const that = this;
			if (!that.updateGeneraler_name.trim()) {
				that.updateGeneralerName_tip = true;
				return false;
			} else {
				that.updateGeneralerName_tip = false;
			}
			if (that.updateGeneraler_sex !== 0 && that.updateGeneraler_sex !== 1) {
				that.updateGeneralerSex_tip = true;
				return false;
			} else {
				that.updateGeneralerSex_tip = false;
			}
			if (!that.ageReg.test(that.updateGeneraler_age)) {
				that.updateGeneralerAge_tip = true;
				return false;
			} else {
				that.updateGeneralerAge_tip = false;
			}
			if (!that.phoneReg.test(that.updateGeneraler_phone)) {
				that.updateGeneralerPhone_tip = true;
				return false;
			} else {
				that.updateGeneralerPhone_tip = false;
			}
			if (!that.updateGeneraler_addr.areaCode) {
				// 校验区域
				that.updateGeneralerAddr_tip = true;
				return false;
			} else {
				that.updateGeneralerAddr_tip = false;
			}
			if (!that.updateGeneraler_hospital) {
				// 校验区域
				that.updateGeneralerHospital_tip = true;
				return false;
			} else {
				that.updateGeneralerHospital_tip = false;
			}
			if (!that.updateGeneraler_doctor) {
				// 校验区域
				that.updateGeneralerDoctor_tip = true;
				return false;
			} else {
				that.updateGeneralerDoctor_tip = false;
			}
			if (!that.updateGeneraler_disease) {
				// 校验区域
				that.updateGeneralerDisease_tip = true;
				return false;
			} else {
				that.updateGeneralerDisease_tip = false;
			}
			if (that.updateGeneraler_nakedR || that.updateGeneraler_nakedL) {
				if (!that.visionReg.test(that.updateGeneraler_nakedR)) {
					// 校验右眼裸眼视力
					that.updateGeneralerNakedR_tip = true;
					return false;
				} else {
					that.updateGeneralerNakedR_tip = false;
				}
				if (!that.visionReg.test(that.updateGeneraler_nakedL)) {
					// 校验左眼裸眼视力
					that.updateGeneralerNakedL_tip = true;
					return false;
				} else {
					that.updateGeneralerNakedL_tip = false;
				}
			} else {
				that.updateGeneralerNakedR_tip = false;
				that.updateGeneralerNakedL_tip = false;
			}
			if (!that.visionReg.test(that.updateGeneraler_correctionR)) {
				// 校验右眼矫正视力
				that.updateGeneralerCorrectionR_tip = true;
				return false;
			} else {
				that.updateGeneralerCorrectionR_tip = false;
			}
			if (!that.visionReg.test(that.updateGeneraler_correctionL)) {
				// 校验左眼矫正视力
				that.updateGeneralerCorrectionL_tip = true;
				return false;
			} else {
				that.updateGeneralerCorrectionL_tip = false;
			}
			that.loading = true;
			var _requestData = {
				age: that.updateGeneraler_age,
				name: that.updateGeneraler_name,
				phone: that.updateGeneraler_phone,
				uareaCode: that.updateGeneraler_addr.areaCode,
				uareaName: that.updateGeneraler_addr.areaName,
				uattendingDoctor: that.updateGeneraler_doctor,
				ucategory: 0,
				ucityCode: that.updateGeneraler_addr.cityCode,
				ucityName: that.updateGeneraler_addr.cityName,
				ucode: that.updateGeneraler_code,
				udiseasesId: that.updateGeneraler_disease,
				uenterpriseId: that.updateGeneraler_hospital,
				uexpert: null,
				uid: that.updateGeneraler_id,
				uleftCva: that.updateGeneraler_correctionL,
				uleftNeva: that.updateGeneraler_nakedL,
				unationalityCode: null,
				unationalityName: null,
				uoverspreadEye: that.updateGeneraler_cover,
				uprovinceCode: that.updateGeneraler_addr.provinceCode,
				uprovinceName: that.updateGeneraler_addr.provinceName,
				urightCva: that.updateGeneraler_correctionR,
				urightNeva: that.updateGeneraler_nakedR,
				memo: that.updateGeneraler_remark,
				sex: that.updateGeneraler_sex
			};
			Api.updateUser(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateGeneraler_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 点击开通产品
		handleGeneralerProductClick(data) {
			const that = this;
			if (!data.agencyId) {
				that.$message.warning('该用户不属于任何机构，暂时无法开通产品！！！');
				return false;
			}
			that.addComplete = false;
			that.getUserProducts(data.code, data.hospitalId, (res) => {
				that.userProducts = res;
				that.generalerProduct_uid = data.id;
				that.generalerProduct_code = data.code;
				that.generalerProduct_hospitalId = data.hospitalId;
				that.generalerProduct_popup_display = true;
			});
		},
		// 开通产品成功
		handleUpdateProduct(msg) {
			const that = this;
			that.generalerProduct_popup_display = false;
			if (that.addComplete) {
				that.generalerPrescription_uid = that.addId;
				that.generalerPrescription_fid = that.addFirmId;
				that.generalerPrescription_code = that.addCode;
				that.generalerPrescription_popup_display = true;
			} else {
				this.$message({
					message: msg,
					type: 'success'
				});
			}
		},
		// 点击充值
		handleRechargeGeneralerClick(data) {
			const that = this;
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法充值！！！');
				return false;
			}
			that.addComplete = false;
			that.rechargeGeneraler_id = data.agencyId;
			that.rechargeGeneraler_name = data.name;
			that.rechargeGeneraler_code = data.code;
			that.getUserProducts(that.rechargeGeneraler_code, that.rechargeGeneraler_id, (res) => {
				if (res.length) {
					that.userProducts = res;
					that.rechargeGeneraler_popup_display = true;
				} else {
					that.$message({
						message: '该用户暂未开通产品，无法充值',
						type: 'warning'
					});
				}
			});
		},
		// 充值成功
		handleRechargeSuccess(msg) {
			this.$message({
				message: msg,
				type: 'success'
			});
			this.rechargeGeneraler_popup_display = false;
		},
		// 点击处方
		handleGeneralerPrescriptionClick(data) {
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法查看处方！！！');
				return false;
			}
			this.addComplete = false;
			this.generalerPrescription_uid = data.id;
			this.generalerPrescription_fid = data.agencyId;
			this.generalerPrescription_code = data.code;
			this.generalerPrescription_popup_display = true;
		},
		// 修改处方
		handleUpdatePrescription(msg) {
			const that = this;
			if (that.addComplete) {
				that.getUserProducts(that.addCode, that.addFirmId, (res) => {
					if (res.length) {
						that.userProducts = res;
						that.rechargeGeneraler_id = that.addFirmId;
						that.rechargeGeneraler_name = that.addName;
						that.rechargeGeneraler_code = that.addCode;
						that.rechargeGeneraler_popup_display = true;
					} else {
						that.$message({
							message: '该用户暂未开通产品，无法充值',
							type: 'warning'
						});
					}
				});
			} else {
				that.$message({
					message: msg,
					type: 'success'
				});
			}
		},
		// 点击训练记录
		handleGeneralerTrainRecordClick(data) {
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法查看训练记录！！！');
				return false;
			}
			this.generalerTrainRecord_uid = data.id;
			this.generalerTrainRecord_fid = data.agencyId;
			this.generalerTrainRecord_code = data.code;
			this.generalerTrainRecord_popup_display = true;
		},
		// 点击重置密码
		handleResetPasswordClick(data) {
			this.resetPassword_oid = data.agencyId;
			this.resetPassword_phone = data.phone;
			this.resetPassword_code = data.code;
			this.resetPassword_display = true;

			// if (this.ucode == "15102199919root") {
			// 	this.resetPassword_oid = data.agencyId;
			// 	this.resetPassword_phone = data.phone;
			// 	this.resetPassword_code = data.code;
			// 	this.resetPassword_display = true;
			// } else {
			// 	this.$message.error('您暂无权限');
			// }
		},
		// 重置密码成功
		handleResetPasswordSuccess(msg) {
			this.$message.success(msg);
			this.resetPassword_display = false;
		},
		// 点击邀请奖励
		handleInviteRewardClick(obj) {
			this.inviteReward_uid = obj.id;
			this.inviteReward_display = true;
		},
		// 点击删除
		handleDeleteClick(data) {
			var requestData = {
				uUserId: data.id
			};
			Api.findUserDetailInfo(requestData).then((res) => {
				if (res.data.success) {
					let arrMap = res.data.data.urlist.map((item) => {
						return {
							urcTime: item.urcTime
						};
					});
					console.log(arrMap);
					if (arrMap.length > 0) {
						const falg = arrMap.every((item) => item.urcTime == 0);
						console.log(falg);
						if (!falg) {
							this.$message.error('剩余次数未用完，删除失败');
							return;
						}
					}
					this.handleDelete(data);
				}
			});
			// const that = this;

			// that.$confirm('此操作将删除该患者，是否继续?', '提示', {
			// 	type: 'warning'
			// })
			// 	.then(() => {
			// 		that.loading = true;
			// 		let requestData = {
			// 			uUserId: data.id
			// 		};
			// 		Api.findUserDetailInfo(requestData).then(
			// 			(res) => {
			// 				if (res.data.success) {
			// 					if (res.data.data.urlist.length) {
			// 						if (res.data.data.urlist[0].urcTime > 0) {
			// 							that.loading = false;
			// 							that.$confirm(`该患者剩余次数${res.data.data.urlist[0].urcTime}，是否继续？`, '提示', {
			// 								type: 'warning'
			// 							})
			// 								.then(() => {
			// 									that.deleteUser(data.id, data.agencyId);
			// 								})
			// 								.catch(() => {});
			// 						} else {
			// 							that.deleteUser(data.id, data.agencyId);
			// 						}
			// 					} else {
			// 						that.deleteUser(data.id, data.agencyId);
			// 					}
			// 				} else {
			// 					that.loading = false;
			// 					that.$message.error(res.data.message);
			// 				}
			// 			},
			// 			(e) => {
			// 				that.loading = false;
			// 				that.$message.error(e.message);
			// 			}
			// 		);
			// 	})
			// 	.catch(() => {});
		},
		//删除
		handleDelete(data) {
			const that = this;
			that.$confirm('此操作将删除该患者，是否继续?', '提示', {
				type: 'warning'
			})
				.then(() => {
					that.loading = true;
					let requestData = {
						uUserId: data.id
					};
					Api.findUserDetailInfo(requestData).then(
						(res) => {
							if (res.data.success) {
								if (res.data.data.urlist.length) {
									if (res.data.data.urlist[0].urcTime > 0) {
										that.loading = false;
										that.$confirm(`该患者剩余次数${res.data.data.urlist[0].urcTime}，是否继续？`, '提示', {
											type: 'warning'
										})
											.then(() => {
												that.deleteUser(data.id, data.agencyId);
											})
											.catch(() => {});
									} else {
										that.deleteUser(data.id, data.agencyId);
									}
								} else {
									that.deleteUser(data.id, data.agencyId);
								}
							} else {
								that.loading = false;
								that.$message.error(res.data.message);
							}
						},
						(e) => {
							that.loading = false;
							that.$message.error(e.message);
						}
					);
				})
				.catch(() => {});
		},
		// 点击病历
		handleGeneralerMedicalClick(data) {
			this.generalerMedical_code = data.code;
			this.generalerMedical_formId = data.hospitalId;
			this.generalerMedical_popup_display = true;
		},
		// 点击健康档案
		handleGeneralerHealthDocClick(data) {
			this.generalerHealthDoc_uid = data.id;
			this.generalerHealthDoc_popup_display = true;
		},
		// 点击回访
		handleGeneralerRevisitClick(data) {
			this.generalerRevisit_uid = data.id;
			this.generalerRevisit_popup_display = true;
		},
		// 新增回访
		addRevisit(msg) {
			this.$message({
				message: msg,
				type: 'success'
			});
			this.generalerRevisit_popup_display = false;
		},
		// 删除回访
		deleteRevisit(msg) {
			this.$message({
				message: msg,
				type: 'success'
			});
			this.generalerRevisit_popup_display = false;
		},
		// 点击充值记录
		handleGeneralerRechargeRecordClick(data) {
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法查看充值记录！！！');
				return false;
			}
			this.generalerRechargeRecord_id = data.agencyId;
			this.generalerRechargeRecord_code = data.code;
			this.generalerRechargeRecord_popup_display = true;
		},
		// 点击消费记录
		handleGeneralerConsumeRecordClick(data) {
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法查看消费记录！！！');
				return false;
			}
			this.generalerConsumeRecord_id = data.agencyId;
			this.generalerConsumeRecord_code = data.code;
			this.generalerConsumeRecord_popup_display = true;
		},

		handlefyClick(data) {
			if (!data.agencyId) {
				this.$message.warning('该用户不属于任何机构，暂时无法查看消费记录！！！');
				return false;
			}
			this.fy_id = data.id;
			this.fy_code = data.code;
			this.fy_popup_display = true;

			console.log(data);
		},

		// 点击带训信息
		handleWithTrainingClick(data) {
			this.widthTraining_code = data.code;
			this.widthTraining_uid = data.id;
			this.widthTraining_firmId = data.hospitalId;
			this.widthTraining_firmName = data.hospitalName;
			this.widthTraining_display = true;
		},
		// 点击备忘录
		handleGeneralerMemoClick(data) {
			this.memo_uid = data.id;
			this.memo_firmId = data.hospitalId;
			this.memo_firmName = data.hospitalName;
			this.memo_code = data.code;
			this.memo_name = data.name;
			this.memo_display = true;
		},
		// 点击AI检查评估报告
		handleAIReportClick(data) {
			this.AIReport_data = {
				...data
			};
			this.AIReport_display = true;
		},

		// 点击充值卡充值
		handleCardActiveClick(data) {
			this.cardActive_id = data.id;
			this.cardActive_display = true;
		},

		/************************ @Function *******************************/
		// 请求数据
		getUserList() {
			const that = this;
			that.loading = true;
			var _requestData = {
				invite: that.invite,
				creater: null,
				endTime: that.generaler_endTime,
				limit: 10,
				pageNum: that.currentPage,
				startTime: that.generaler_startTime,
				uareaName: that.generaler_addr.areaName,
				ucityName: that.generaler_addr.cityName,
				ucode: that.generaler_code,
				udiseasesId: that.generaler_disease,
				uenterpriseName: that.generaler_hospital,
				ufinderCategory: null,
				uid: null,
				uloginerCategory: that.authInfo.ucategory,
				uphone: null,
				uprovinceName: that.generaler_addr.provinceName,
				username: that.generaler_name,
				userId: that.authInfo.uid,
				uenterpriseId: that.authInfo.uenterpriseId,
				functionType: 1
			};
			Api.findUser(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0; i < res.data.data.data.length; i++) {
							that.tableData.push({
								id: res.data.data.data[i].uid,
								agencyId: res.data.data.data[i].uenterpriseId,
								diseaseId: res.data.data.data[i].udiseasesId || '',
								diseaseName: res.data.data.data[i].udiseasesName || '',
								code: res.data.data.data[i].ucode || '',
								name: res.data.data.data[i].name || '',
								phone: res.data.data.data[i].phone || '',
								sex: res.data.data.data[i].sex || '',
								sexLabel: res.data.data.data[i].sex == 0 ? '男' : res.data.data.data[i].sex == 1 ? '女' : '',
								age: res.data.data.data[i].age || '',
								doctorId: res.data.data.data[i].uattendingDoctor || '',
								doctorName: res.data.data.data[i].doctorName || '',
								hospitalId: res.data.data.data[i].uenterpriseId || '',
								hospitalName: res.data.data.data[i].uenterpriseName || '',
								creater: res.data.data.data[i].creater || '',
								creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split('T')[0] : '',
								provinceName: res.data.data.data[i].uenterpriseProvinceName || '',
								provinceCode: res.data.data.data[i].uenterpriseProvinceCode || '',
								cityName: res.data.data.data[i].uenterpriseCityName || '',
								cityCode: res.data.data.data[i].uenterpriseCityCode || '',
								areaName: res.data.data.data[i].uenterpriseAreaName || '',
								areaCode: res.data.data.data[i].uenterpriseAreaCode || '',
								nakedR: res.data.data.data[i].urightNeva || '',
								nakedL: res.data.data.data[i].uleftNeva || '',
								correctionR: res.data.data.data[i].urightCva || '',
								correctionL: res.data.data.data[i].uleftCva || '',
								cover: res.data.data.data[i].uoverspreadEye ? parseInt(res.data.data.data[i].uoverspreadEye) : -1,
								coverName: BaseMethods.mapCoverToName(res.data.data.data[i].uoverspreadEye),
								remark: res.data.data.data[i].memo || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 删除用户
		deleteUser(uid, oid) {
			const that = this;
			var _requestData = {
				uCategory: 0,
				uId: uid,
				uenterpriseId: oid
			};
			Api.deleteUser(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取新增医院
		findAddHospital(isFirst) {
			const that = this;
			that.add_loading = true;
			var _requestData = {
				uAreaCode: that.addGeneraler_addr.areaCode,
				uCategory: 5,
				uCode: that.authInfo.ucode
			};
			Api.findFirmsByArea(_requestData).then(
				(res) => {
					that.add_loading = false;
					if (res.data.success) {
						let next = that.authInfo.ucategory == 3 && isFirst;
						that.addGeneraler_hospitals = [];
						res.data.data.forEach((v) => {
							next && that.authInfo.uenterpriseId == v.uenterpriseId && (that.addGeneraler_hospital = v.uenterpriseId);
							that.addGeneraler_hospitals.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						if (next) {
							// that.addGeneraler_hospital = that.addGeneraler_hospitals.length
							// 	? that.addGeneraler_hospitals[0].id
							// 	: '';
							that.addGeneraler_hospital && that.findAddDoctors(isFirst);
						}
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取新增医生
		findAddDoctors(isFirst) {
			const that = this;
			that.add_loading = true;
			const requestData = {
				id: null,
				uenterpriseId: that.addGeneraler_hospital
			};
			Api.findDoctorsByForm(requestData).then(
				(res) => {
					that.add_loading = false;
					if (res.data.success) {
						let next = that.authInfo.ucategory == 3 && isFirst;
						that.addGeneraler_doctors = [];
						res.data.data.forEach((v) => {
							v.uid == that.authInfo.uid && next && (that.addGeneraler_doctor = that.authInfo.uid);
							that.addGeneraler_doctors.push({
								uid: v.uid,
								hospitalId: v.uenterpriseId,
								name: v.uname
							});
						});
						if (next) {
							// if (!that.addGeneraler_doctor) {
							// 	that.addGeneraler_doctor = that.addGeneraler_doctors.length
							// 		? that.addGeneraler_doctors[0].uid
							// 		: '';
							// }
							that.addGeneraler_doctor && that.findAddDiseaseByDoctor(isFirst);
						}
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 根据医生id获取新增医生的病理类型
		findAddDiseaseByDoctor(isFirst) {
			const that = this;
			that.add_loading = true;
			const requestData = {
				buserId: that.addGeneraler_doctor
			};
			Api.findDiseaseByDoctor(requestData).then(
				(res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.add_loading = false;
						let next = that.authInfo.ucategory == 3 && isFirst;
						let list = [];
						res.data.data.forEach((v) => {
							list.push({
								id: v.uid,
								name: v.uname
							});
						});
						that.addGeneraler_diseases = list;
						next && (that.addGeneraler_disease = list.length ? list[0].id : '');
					} else {
						that.add_loading = false;
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取更新医院
		findUpdateHospital(data) {
			const that = this;
			data = data ? data : {};
			that.update_loading = true;
			var _requestData = {
				uAreaCode: that.updateGeneraler_addr.areaCode,
				uCategory: 5,
				uCode: that.authInfo.ucode
			};
			Api.findFirmsByArea(_requestData).then(
				(res) => {
					that.update_loading = false;
					if (res.data.success) {
						var already = false;
						that.updateGeneraler_hospitals = [];
						res.data.data.forEach((v) => {
							data.hospitalId == v.uenterpriseId && (already = true);
							that.updateGeneraler_hospitals.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						if (already) {
							that.updateGeneraler_hospital = data.hospitalId;
						}
						// else
						// 	that.updateGeneraler_hospital = that.updateGeneraler_hospitals.length
						// 		? that.updateGeneraler_hospitals[0].id
						// 		: '';
						that.updateGeneraler_hospital && that.findUpdateDoctors(data);
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取更新医生
		findUpdateDoctors(data) {
			const that = this;
			data = data ? data : {};
			that.update_loading = true;
			const requestData = {
				id: null,
				uenterpriseId: that.updateGeneraler_hospital
			};
			Api.findDoctorsByForm(requestData).then(
				(res) => {
					that.update_loading = false;
					if (res.data.success) {
						var already = false;
						that.updateGeneraler_doctors = [];
						res.data.data.forEach((v) => {
							data.doctorId == v.uid && (already = true);
							that.updateGeneraler_doctors.push({
								uid: v.uid,
								hospitalId: v.uenterpriseId,
								name: v.uname
							});
						});
						if (already) {
							that.updateGeneraler_doctor = data.doctorId;
						}
						// else
						// 	that.updateGeneraler_doctor = that.updateGeneraler_doctors.length
						// 		? that.updateGeneraler_doctors[0].uid
						// 		: '';
						that.updateGeneraler_doctor && that.findUpdateDiseaseByDoctor(data);
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 根据医生id获取更新医生的病理类型
		findUpdateDiseaseByDoctor(data) {
			const that = this;
			data = data ? data : {};
			that.update_loading = true;
			const requestData = {
				buserId: that.updateGeneraler_doctor
			};
			Api.findDiseaseByDoctor(requestData).then(
				(res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.update_loading = false;
						let list = [];
						res.data.data.forEach((v) => {
							list.push({
								id: v.uid,
								name: v.uname
							});
						});
						that.updateGeneraler_diseases = list;
						// that.updateGeneraler_disease = data.diseaseId ? data.diseaseId : (list.length ? list[0].id : '');
						that.updateGeneraler_disease = data.diseaseId ? data.diseaseId : '';
					} else {
						that.update_loading = false;
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 比较开始时间和结束时间
		compareSearchTime() {
			if (this.generaler_startTime && this.generaler_endTime) {
				var startTime = new Date(this.generaler_startTime).getTime(),
					endTime = new Date(this.generaler_endTime).getTime();
				if (endTime < startTime) {
					this.generaler_endTime = '';
					this.$message.warning('结束时间不能小于开始时间');
				}
			}
		},
		// 获取用户开通的产品
		getUserProducts(code, firmId, callBack) {
			const that = this;
			that.loading = true;
			var requestData = {
					inputPhoneNum: code,
					uenterpriseId: firmId
				},
				result = [];
			Api.getUserProducts(requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						for (var i = 0; i < res.data.data.length; i++) {
							result.push({
								id: res.data.data[i].productId,
								name: res.data.data[i].productName
							});
						}
						callBack && callBack(result);
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取用户信息
		findUserInfo(code, callBack) {
			const that = this;
			that.loading = true;
			const requestData = {
				uCode: code,
				type: 'w'
			};
			Api.findUserInfo(requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success && res.data.data) {
						callBack && callBack(res.data.data);
					} else {
						that.$message.error('该患者不存在');
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		}
	},
	components: {
		AreaChoise,
		ResetPassword,
		InviteReward,
		Recharge,
		RechargeRecord,
		ConsumeRecord,
		FyRecord,
		TrainingRecord,
		Prescription,
		Product,
		ReVisit,
		Medical,
		HealthDoc,
		WithTraining,
		Memo,
		AIReport,
		CardActive
	}
};
</script>

<style scoped></style>
